// extracted by mini-css-extract-plugin
module.exports = {"cta":"GetTheAppButton-module__cta___I2btj"};